export default {
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },
  SET_SCORE(state, payload) {
    state.score = payload;
  },
  SET_COINS(state, payload) {
    state.coins = payload;
  },
  SET_LIFE(state, payload) {
    state.life = payload;
  },
  SET_LEVEL(state, payload) {
    state.level = payload;
  },
  SET_MODE(state, payload) {
    state.mode = payload;
  },
  SET_USER_DATA(state, payload) {
    state.userData = payload;
  },
};
